<section class="w-full d-flex justify-center {{ backgroundColor }}">
  <div [style.max-width.px]="maxWidth" class="p-20 w-full">
    <ng-content></ng-content>
  </div>
</section>
